import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Database, get, ref, update } from '@angular/fire/database';
import { map } from 'rxjs/operators';
import { GlobalsService } from './globals.service';
import { from } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class UnitBalanceService {
  fbFunctionURL: string = '';
  coreAPI: string = '';

  constructor(private db: Database, private http: HttpClient, private globals: GlobalsService) {
    this.fbFunctionURL = this.globals.fbFunctionURL;
    this.coreAPI = this.globals.coreAPI;

  }


  createCompanyBalance(request) {
    return this.http.post(this.fbFunctionURL + 'createCompaniesBalance', request);
  }

  creditBalanceCheck(request) {
    return this.http.post(this.fbFunctionURL + 'unitBalanceCheck', request);

  }

  fetchSurveys() {
    const surveysRef = ref(this.db, 'SurveyUnitCount');

    return from(get(surveysRef)).pipe(
      map(snapshot => {
        if (!snapshot.exists()) return null;
        return {
          key: snapshot.key,
          ...snapshot.val()
        };
      })
    );
  }

  updateUnitBalance(unitRequest: any) {
    const path = `TenantUnitRequests/${unitRequest.tenantKey}/${unitRequest.key}`;
    const unitRef = ref(this.db, path);
    return update(unitRef, unitRequest);
  }

  fetchTenantCompanyBalance(request) {
    return this.http.post(this.fbFunctionURL + 'tenantCompanyBalance', request);
  }


  requestMoreUnitsFromSuperAdmin(request) {
    return this.http.post(this.fbFunctionURL + 'requestMoreUnitsFromSuperAdmin', request);
  }
  requestMoreUnitsFromTenantAdmin(request) {
    return this.http.post(this.fbFunctionURL + 'requestMoreUnitsFromTenantAdmin', request);
  }


  distributeUnitsToCompany(request) {
    return this.http.post(this.fbFunctionURL + 'distributeUnitsToCompany', request);
  }

  getProductExpiry(request:{ tenantKey: string, product?: string}) {
    return this.http.post(this.coreAPI + 'units-management/entity-balances/tenant/product-expiry', request);
  }

}
